<template>
  <div class="the-operation">
    <header>
      <h1><router-link to="/main">
          API Service Platform
      </router-link></h1>
      <h2>
        <router-link to="/main">Powered by K-lab</router-link>
      </h2>
      <div class="login-button">
        <router-link to="/main" v-if="LoggedIn">
          <button @click="logout">ログアウト</button>
        </router-link>
        <router-link to="/userlogin" v-else>
          <button>ログイン</button>
        </router-link>
      </div>
    </header>
    <div class="navbar">
      <router-link class="box" to="/main">Main</router-link>
      <router-link class="box" to="/opendataupload">
        Upload Open data/Registered system
      </router-link>
      <router-link class="box" to="/opendatacatalog">
        Find Open data/Registered system
      </router-link>
      <router-link class="box" to="/userinfo">User Center</router-link>
    </div>
  </div>
</template>

<script setup>
  import { useUserStore } from "../store/user.js";
  import { ref } from "vue";

  const userStore = useUserStore();
  const username = ref(userStore.username);
  const LoggedIn = ref(userStore.userLogged);
  const times = ref(userStore.times);
  const persons = ref(userStore.persons);
  const loginpersons = ref(userStore.loginpersons);

  userStore.$subscribe(() => {
    username.value = userStore.username;
    LoggedIn.value = userStore.userLogged;
    times.value = userStore.times;
    persons.value = userStore.persons;
    loginpersons.value = userStore.loginpersons;
  });
  function logout() {
    userStore.logout();
  }
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}

.the-operation {
  position: sticky;
  top: 0;
  z-index: 9999;
}

header {
  /* position: fixed; */
  /* margin-top:-32px ; */
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #18191c;
  color: antiquewhite;

  z-index: 9999;
}
.navbar{
  width: 100%;
  height: 3rem;
  display: flex;
  justify-content: space-around;
  z-index: 9998;
}
.box {
  font-size: 12px;
  width: 100%;
  border: antiquewhite 1px solid;
  background-color: #18191c;
  color: antiquewhite;
  text-align: center;
  line-height: 2rem;
}
h1 {
  font-weight: 800;
}
h2 {
  margin-bottom: 30px;
  margin-left: 7px;
  font-size: 12px;
  font-weight: normal;
}
.login-button {
  position: absolute;
  left: 10px;
  top: 10px;
}
.humberger {
  position: absolute;
  /*子要素に対する起点*/
  margin-top: 3px;
  margin-right: 10px;
  height: 36px;
  width: 36px;
  background-color: #18191c;
  border: 2px solid antiquewhite;
  border-radius: 4px;
  right: 0%;
}
.humberger span {
  position: absolute;
  /*親要素に対して固定表示*/
  left: 10px;
  height: 4px;
  width: 26px;
  background-color: antiquewhite;
  border-radius: 2px;
}
.humberger span:nth-of-type(1) {
  top: 4px;
}
.humberger span:nth-of-type(2) {
  top: 14px;
}
.humberger span:nth-of-type(3) {
  bottom: 4px;
}
</style>